import GetDynamicFormByIdRequestModelBase from '../_generated/modelBases/get-dynamic-form-by-id-request-model-base';

export default class GetDynamicFormByIdRequestModel extends GetDynamicFormByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
